import React from 'react'
import { Done } from 'emotion-icons/material'
import Brandy from '../../Brandy'
import ListItem from '../../List/ListItem'
import * as Styled from './Bullets.styles'

const Bullets = ({ bullets = [], noSpacing = false }) => {
  if (bullets?.length === 0) {
    return null
  }

  return (
    <>
      {bullets.length > 0 && (
        <Styled.Bullets className="bullets" noSpacing={noSpacing}>
          {bullets.map((bullet) => (
            <ListItem
              className="list-item"
              key={bullet.text}
              icon={<Done />}
              inPackageCard
            >
              <Brandy className="brandy" text={bullet.text} variant="body" />
              {bullet.disclaimer && (
                <Brandy
                  className="bullet-disclaimer"
                  symbol={bullet.disclaimer.symbol}
                  text={bullet.disclaimer.text}
                  variant="legal"
                />
              )}
            </ListItem>
          ))}
        </Styled.Bullets>
      )}
    </>
  )
}

export default Bullets
